import * as turf from "@turf/turf";
import React, { useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import { State } from "../context/State";
import "./component.css";
import { fitBounds, randomBetween, uniqueId } from "./util";
import Link from "./Link";
const newPoint = (x, y) => {
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: [x, y]
    },
    properties: { name: `Random point (${y}, ${x})` }
  };
};

const clickRandom = ({ view, setView, addLayer }) => {
  const x = randomBetween(-120, 140);
  const y = randomBetween(-30, 65);
  const layer = newPoint(x, y);

  addLayer({ layer });
  setView({ ...view, zoom: 3.3, latitude: y, longitude: x });
};

export const RandomFeatures = () => {
  const { mapRef, layers, addLayer, view, setView, showLibrary } = useContext(
    State
  );
  const viewportAsLayer = () => {
    console.log(mapRef);
    const v = mapRef.current.getMap().getBounds();
    const arr = [v._sw.lng, v._sw.lat, v._ne.lng, v._ne.lat];
    console.log(arr);

    const l = turf.bboxPolygon(arr);
    console.log({ l });

    addLayer({ layer: l, name: "Viewport" });
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Link onClick={() => clickRandom({ setView, addLayer, view })}>
        Add Random Point
      </Link>
      <Link
        onClick={() => {
          var f = turf.randomPolygon(1, {
            num_vertices: randomBetween(3, 8),

            bbox: [-120, -30, 140, 65]
          });
          const id = uniqueId();
          const shortId = id.substring(id.length - 3);
          addLayer({ layer: f, name: `Random feature ${shortId}`, id });
          fitBounds({ view, setView, layer: f, showLibrary });
        }}
      >
        Add Feature
      </Link>
      <Link onClick={() => viewportAsLayer()}>Viewport As Layer</Link>
    </div>
  );
};
